/**
 * How to reach the business, as the website publishes it, in one place so every screen says the
 * same number, the same address and the same hours.
 */
export const PHONE_HREF = 'tel:+17273377775';
export const PHONE_SHOWN = '(727) 337-7775';
export const EMAIL_SHOWN = 'hello@faithfullykept.com';
export const EMAIL_HREF = `mailto:${EMAIL_SHOWN}`;
/**
 * The website's published hours, its `src/site.config.ts` `hours.regular`, which the owner moved
 * from 08:00 to 09:00 on 2026-09-03 to match the Google Business Profile. The NoMembership artboard
 * still says 08:00, copied before that change. Held to the website's figures in `contact.test.ts`.
 */
export const HOURS = 'Monday to Saturday, 09:00 to 18:00.';

/** The website's own pages a signed-in screen links to: its privacy, terms and policy pages. */
export const PRIVACY_HREF = 'https://faithfullykept.com/privacy/';
export const TERMS_HREF = 'https://faithfullykept.com/terms/';
export const POLICY_HREF = 'https://faithfullykept.com/cancellation-and-reclean-policy/';
